import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useFilterContext } from "../../hooks/FilterContext";
import LeagueTable from "./components/LeagueTable";
import { AdviserLeagueTableModal } from "./components/AdviserLeagueTableFilters";
import useAdviserLeagueTable from "./hooks/useAdviserLeagueTable";
import { Button } from "../../components";
//import PageHeader from "../../components/layout/PageHeader";
import { PageSubHeader, ThemedIcon, ThemedParagraph } from "../../components/utilities";

const AdviserLeagueTablePageSubHeader = styled(PageSubHeader)`
    position: sticky;
    padding: 0.75rem;
`;

const AdviserLeagueTableFiltersAppliedWarningMessage = styled(ThemedParagraph)`
    font-size: 12px !important;
`;

const ManagementReportsLeagueTable = () => {
    const [isFiltersShown, setIsFiltersShown] = useState(false);
    const { clearFilter, isFiltersApplied, filter } = useFilterContext();

    const { data, error, isLoading, isFetching } = useAdviserLeagueTable();
    
    const [reportDate, setReportDate] = useState();

    useEffect(() => {
        setReportDate(filter.reportDate.split('-').reverse().join('/'));
    }, [ filter ]);

    const tableLabel = `Adviser League Table ${reportDate}`;
      
    return <React.Fragment>
        <AdviserLeagueTableModal
            //handleClose={() => {setIsFiltersShown(false);setReportDate(filter.reportDate.split('-').reverse().join('/'))}}
            handleClose={() => setIsFiltersShown(false)}
            show={isFiltersShown}
        />
        <AdviserLeagueTablePageSubHeader>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    {isFiltersApplied && (
                        <React.Fragment>
                            <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <AdviserLeagueTableFiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                </AdviserLeagueTableFiltersAppliedWarningMessage>
                        </React.Fragment>
                    )}
                </div>
                <div className="d-flex">
                    <Button onClick={() => setIsFiltersShown(true)}>Filter Report</Button>
                </div>
            </div>
        </AdviserLeagueTablePageSubHeader>

        <section className="h-100 px-4 my-3">
            <LeagueTable label={tableLabel} data={data} error={error} isLoading={isLoading === true || isFetching === true} />
        </section>
    
    </React.Fragment>;

    


};

export default ManagementReportsLeagueTable